import React from 'react';
import './index.scss'; 

export const LeftTriangle = ({ onClick }: { onClick?: () => void; }) => (
  <div className="dbg-left-triangle-container" onClick={onClick}>
    <div className={`triangle-left`} />
    <div className={`triangle-right`} />
  </div>
);
